export interface UtilityConfig {
  protocol: string;
  host: string;
  port: string;
  timeoutMs: number;
}

export const utilityConfig: UtilityConfig = {
  protocol: 'http',
  host: 'localhost',
  port: '5050',
  timeoutMs: 3000,
};

export const UtilityEndpoints = {
  getPcInfo: '/seat-info',
  publicKey: '/public-key',
  health: '/health',
} as const;

export type UtilityEndpoint = (typeof UtilityEndpoints)[keyof typeof UtilityEndpoints];
